module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "selector-button",
    class: _vm.activeClass,
    style: (_vm.style),
    on: {
      "click": _vm.clickButton
    }
  }, [(_vm.isNoDate) ? _c('div', {
    staticClass: "selector-button__indicator"
  }, [_c('div', {
    staticClass: "selector-button__tooltip"
  }, [_vm._v("Внимание! Есть материалы без указанной даты")])]) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e9b2506","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/selector/components/button/SelectorButton.vue
// module id = 50ed224efc73d58b1012
// module chunks = 7